import { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import LangSync from "@/components/LangSync";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import HowItWorks from "@/pages/HowItWorks";
import Technology from "@/pages/Technology";
import Governance from "@/pages/Governance";
import Resources from "@/pages/Resources";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Media from "@/pages/Media";
import Awards from "@/pages/Awards";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

// Shared nested route tree (excluding the outer Layout wrapper).
// Rendered both at the root (English) and under /fr and /pt so the same
// React tree serves all three locales with SEO-friendly URLs.
function SiteChildRoutes() {
  return (
    <>
      <Route index element={<Home />} />
      <Route path="solutions" element={<Solutions />} />
      <Route path="how-it-works" element={<HowItWorks />} />
      <Route path="technology" element={<Technology />} />
      <Route path="governance" element={<Governance />} />
      <Route path="resources" element={<Resources />} />
      <Route path="case-studies" element={<CaseStudies />} />
      <Route path="case-studies/:slug" element={<CaseStudyDetail />} />
      <Route path="media" element={<Media />} />
      <Route path="awards" element={<Awards />} />
      <Route path="contact" element={<Contact />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="*" element={<NotFound />} />
    </>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("scroll-smooth");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LangSync />
        <Routes>
          {/* English (default, no prefix) */}
          <Route path="/" element={<Layout />}>
            {SiteChildRoutes()}
          </Route>
          {/* French — /fr/... */}
          <Route path="/fr" element={<Layout />}>
            {SiteChildRoutes()}
          </Route>
          {/* Portuguese — /pt/... */}
          <Route path="/pt" element={<Layout />}>
            {SiteChildRoutes()}
          </Route>
          {/* Explicit /en — mirrors the default English tree */}
          <Route path="/en" element={<Layout />}>
            {SiteChildRoutes()}
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
